import { type CAPITAL_PARTNER_NETWORK_CONTENT } from '../content';
import {
  CardGrid,
  ContentContainer,
  Section,
  SectionEyebrow,
  SectionIntro,
  SectionLead,
  SectionTitle,
  SurfaceCard,
  SurfaceText,
  SurfaceTitle,
} from '../styles';

type WhoShouldJoinCopy = (typeof CAPITAL_PARTNER_NETWORK_CONTENT)['whoShouldJoin'];

type WhoShouldJoinSectionProps = {
  copy: WhoShouldJoinCopy;
};

export default function WhoShouldJoinSection({
  copy,
}: WhoShouldJoinSectionProps) {
  return (
    <Section>
      <ContentContainer>
        <SectionIntro $wide>
          <SectionEyebrow>{copy.eyebrow}</SectionEyebrow>
          <SectionTitle>{copy.title}</SectionTitle>
          <SectionLead>{copy.body}</SectionLead>
        </SectionIntro>
        <CardGrid $columns={5}>
          {copy.profiles.map((profile) => (
            <SurfaceCard key={profile}>
              <SurfaceTitle>{profile}</SurfaceTitle>
              <SurfaceText>
                Best fit when signal, timing, and alignment matter more than volume.
              </SurfaceText>
            </SurfaceCard>
          ))}
        </CardGrid>
      </ContentContainer>
    </Section>
  );
}
